module.exports = __webpack_public_path__ + "1642699981952/static/media/authBastaoAmarelo.1f2891e0.svg";